import { validatePresence, validateNumber } from 'ember-changeset-validations/validators';
import validateOnCheck from 'volta/validators/on-check';

export default {
  acqCode: [validatePresence(true)],
  leadTime: validateNumber({ gt: 0, allowBlank: false, integer: true }),
  internalLeadTime: [
    validateNumber({ positive: true, allowBlank: true, integer: true }),
    validateOnCheck({
      checkKeys: ['leadTime'],
      checkCondition: (internalLeadTime: number = 0, leadTime: number = 0) => {
        return internalLeadTime <= leadTime;
      },
      i18nKey: 'internalLeadTime',
      i18nType: 'lessThan',
      i18nContext: (_ilt: number, lt: number = 0) => ({ lt })
    })
  ],
  minOrderQty: validateNumber({ positive: true, allowBlank: true }),
  maxPOQty: validateNumber({ positive: true, allowBlank: true }),
  orderMultiple: validateNumber({ positive: true, allowBlank: true }),
  inventoryUnitPrice: validateNumber({ positive: true, allowBlank: true }),
  salesUnitPrice: validateNumber({ positive: true, allowBlank: true }),
  tags: [],
  warehouse: { warehouseId: validatePresence(true) },
  part: {
    partId: [],
    unitMeasure: validatePresence(true),
    code: validatePresence(true)
  },
  partType: []
};
